const EVENT_PREFIX = 'WebPOS - ';

export default class Analytics {
  static init() {}

  /**
   * Submits an analytics event.  The event will be prefixed with 'WebPOS - '.
   *
   * @param {string} event       A string used to identify the type of event
   * @param {object} data        An optional object hash containing data to transmit with the event
   * @param {string} eventPrefix Override the default event prefix
   */
  static track(_event: string, _data = {}, _eventPrefix = EVENT_PREFIX) {
    // All MixPanel tracking code has been abandoned in favor of a GA integration
    // Could delete this class but perhaps better if it stays there in case questions are asked
  }
}

// Make the class available to non-ES6 legacy code.  This is a workaround
// until we lose all ES5 support (whenever that is).
window.Analytics = Analytics;
